'use strict';
'use es6';

// Added this as a one off to fix the post filter widget. This wiring was
// previously included in public_common via common_init.js

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PostFilterWidget = function () {
  function PostFilterWidget() {
    _classCallCheck(this, PostFilterWidget);

    this.getShowAllFiltersLinkEventHandler = function (link) {
      return function (event) {
        var children = link.previousElementSibling.children;


        if (children) {
          [].slice.call(children, 0).forEach(function (child) {
            child.style.display = 'block';
          });
        }

        link.style.display = 'none';

        event.preventDefault();
        event.stopPropagation();
      };
    };
  }

  _createClass(PostFilterWidget, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      var filterLinksNodes = [].slice.call(document.querySelectorAll('.filter-expand-link'), 0);
      filterLinksNodes.forEach(function (link) {
        link.addEventListener('click', _this.getShowAllFiltersLinkEventHandler(link));
      });
    }
  }]);

  return PostFilterWidget;
}();

exports.default = PostFilterWidget;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/PostFilterWidget.js
// module id = 7
// module chunks = 0 1